export function init(pk?: string): void {
	import('./view')
		.then(mod => (new mod.PriceUpdateView(pk)));
}
